export let dict = [
	# wordCham: "cham"
	# wordIpa: "cam (ipa)"
	# wordReviewed: false
	# wordNotes: "notes"
	# engArray: [
	# 	engWord: "eng"
	# 	engInfo: "info"
	# 	engUse: "use"
	# 	]
	# khArray: [
	# 	khWord: "kh"
	# 	khInfo: "khipa"
	# 	khUse: ""
	# 	]
	# ---
	wordCham: "aai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "older sibling"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "aai aai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "You"
		engInfo: "For addressing several people older that the speaker"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: "bong bong"
		khUse: ""
		]
	---
	wordCham: "aai-kamaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "older sister"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: "bong bong"
		khUse: ""
		]
	---
	wordCham: "aai-lakaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "older brother"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "aai-saaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "older sibling in law"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "aai-saaŋ kamaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "older sister in law"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "aaw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "shirt, clothing top"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: "aaw ea-c̱ean"
		khUse: ""
		]
	---
	wordCham: "aaw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "rain coat"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "akan"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "will, about to, (future tense auxiliary)"
		engInfo: "Not often used. Borrowed from the Malay Langauge."
		engUse: "auxiliary"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "Amereik"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "America"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "Asalaa˙mualaikum"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "Hello!"
		engInfo: "Said by Initial greeter. Recriprocal greeting must be «Wēa̱laikum˙musalaam»"
		engUse: "exclamation"
		---
		engWord: "to greet, to say hello"
		engInfo: "only for initial greeter, Wēa̱laikum˙musalaam must be used in response"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: "cumria̱p-sua̱"
		khUse: ""
		]
	---
	wordCham: "ataaw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "or"
		engInfo: ""
		engUse: "conj"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "atai-p˙p̱ih"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the last one"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "baa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "bar, nightclub"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "baal"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "ball"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "baal-ṯīt"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "foot-ball (soccer)"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "baaw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "smell"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "baaw-k˙jah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "stinky, bad-smelling"
		engInfo: ""
		engUse: "adjective?"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "baaw-p˙guq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "foul-smelling, as from a dead animal"
		engInfo: ""
		engUse: "adjective?"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "baaw-phaa̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "fragrant, good-smelling, sweet-smelling"
		engInfo: ""
		engUse: "adjective?"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "baep"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "kind, variety"
		engInfo: ""
		engUse: "specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ba̱ng"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to eat"
		engInfo: "Used for non-rice food"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "baŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "time(s), occasion(s), occurrence(s)"
		engInfo: "to be prefixed by a numerator like (ha-,toa-)"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "baq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "salty"
		engInfo: ""
		engUse: "adjective"
		---
		engWord: "salted"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "bat˙tbōōŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "The city or province of battambong"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: "battambōng"
		khUse: ""
		]
	---
	wordCham: "p˙guq hīt"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "work, affairs, chores"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: "kaa"
		khUse: ""
		]
	---
	wordCham: "p˙guq hīt ŋa˙ba̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "job, career, profession"
		engInfo: "A method of earning a living."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: "l˙bōō"
		khUse: ""
		]
	---
	wordCham: "p˙guq ṯoah kaan"
	wordIpa: ""
	wordReviewed: false
	wordNotes: "work / look for / fish"
	engArray: [
		engWord: "fishing"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙guq mataai "
	wordIpa: "mataai is often spoken as (m˙taai)"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "death"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙guq ŋak ma̱u̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "rice-farming"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙guq ṯo-ṯuol tua̱i"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "guest hosting (work of receiving guests_"
		engInfo: "The work of hosting / receiving guests"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙guq m˙yea̱i"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "speaking"
		engInfo: "The work of speaking"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙guq m˙yea̱i"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "speaking"
		engInfo: "The work of speaking"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "bia̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "playing-cards"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "bih-gaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "late afternoon, evening"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "bih-gaai?"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "early afternoon"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱lean"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "month"
		engInfo: ""
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱lean c̱ean"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the rainy season"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱lean l˙an"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the cold season"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱lean p˙deaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the hot season"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱law-bia̱wq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the hot season"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱lōh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "already, indeed"
		engInfo: ""
		engUse: "adverb"
		---
		engWord: "then, and then"
		engInfo: ""
		engUse: "conjunction"
		---
		engWord: "to finish, to complete"
		engInfo: ""
		engUse: "completive verb"
		]
	khArray: [
		khWord: ""
		khInfo: "haa̱i"
		khUse: ""
		---
		khWord: ""
		khInfo: "cap"
		khUse: ""
		]
	---
	wordCham: "p̱lōh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "already, indeed"
		engInfo: ""
		engUse: "adverb"
		---
		engWord: "then, and then"
		engInfo: ""
		engUse: "conjunction"
		---
		engWord: "to finish, to complete"
		engInfo: ""
		engUse: "completive verb"
		]
	khArray: [
		khWord: ""
		khInfo: "haa̱i"
		khUse: ""
		---
		khWord: ""
		khInfo: "cap"
		khUse: ""
		]
	---
	wordCham: "p̱lōh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "already, indeed"
		engInfo: ""
		engUse: "adverb"
		---
		engWord: "then, and then"
		engInfo: ""
		engUse: "conjunction"
		---
		engWord: "to finish, to complete"
		engInfo: ""
		engUse: "completive verb"
		]
	khArray: [
		khWord: ""
		khInfo: "haa̱i"
		khUse: ""
		---
		khWord: ""
		khInfo: "cap"
		khUse: ""
		]
	---
	wordCham: "p̱lōh moŋ non, haṯaai moŋ non"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "after that"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱lōh yūū"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "finished already"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱lōh yūū ṯōōq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "..yet?, ...already?, ...not yet?"
		engInfo: ""
		engUse: "adverb, interrogative"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "bloŋ ea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to sink"
		engInfo: ""
		engUse: "completive verb"
		]
	khArray: [
		khWord: ""
		khInfo: "luŋ"
		khUse: ""
		]
	---
	wordCham: "p̱ŋuu"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "flower"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "boh"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to see, to perceive"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "boh-t˙gaa"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to stamp with a seal"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: "boh-traa"
		khUse: ""
		]
	---
	wordCham: "bok"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to collide with, to run into, to crash, to bump into"
		engInfo: "As crashing a car, or bumping unto a tree"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "bom-baek"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to break, to cause to break"
		engInfo: "Borrowed from khmer"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙baik"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "To separate, to cause to seaparate"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "bom-nooŋ"
	wordIpa: "borrowed from khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "hope, aim, intention"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "tai khīn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "wish, hope"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "bom-phot"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "most, last, most of all"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙pīh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the last, the end, the tip"
		engInfo: "The end (or front) of the line, the tip of the tree"
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: "bom-phot"
		khUse: ""
		]
	---
	wordCham: "boŋ-aem"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "sweets, desserts"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "boom"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to pump out, to suck out"
		engInfo: "Pumping water"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "bōt"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "pencil"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "bouq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "hair"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱eaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be right, to be true"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱iq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to throw (underhanded)"
		engInfo: "A slow throw for someone to catch an object"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qlom"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to throw (fast)"
		engInfo: "As to throw a stone to knock down a mango. Not to be catched."
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱iq-c˙not"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to elect"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱ōh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to touch, to feel (for)"
		engInfo: "to touch or feel something or someone"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱oh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to beat or slam (something in your hand)"
		engInfo: "To slam a rug to get the dust out, or to slam a wrestler on the ground."
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱uu"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "rice-water soup"
		engInfo: "A kind of soup that has a lot of water and only a little bit of rice"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: "bōbāā"
		khUse: ""
		]
	---
	wordCham: "ba̱ŋ"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "lake, pond"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "biyea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "beer"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "Billiard, Snooker, Pool"
		engInfo: "A table game"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "biyea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "beer"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "Billiard, Snooker, Pool"
		engInfo: "A table game"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙p̱ea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "bland, unseasoned"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙baih"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be clear"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ṯat"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a permit, permission"
		engInfo: "Normally as a document from the government"
		engUse: "noun"
		---
		engWord: "the law"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: "c˙bap"
		khUse: ""
		]
	---
	wordCham: "ṯat"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a permit, permission"
		engInfo: "Normally as a document from the government"
		engUse: "noun"
		---
		engWord: "the law"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: "c˙bap"
		khUse: ""
		]
	---
	wordCham: "c˙bow"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to spread out, to expose to"
		engInfo: "As when putting fish to dry in the sun"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙bua̱i"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "mouth"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙bua̱i-k˙g̱a̱a̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "river bank"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "koq haaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "cliff"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙gah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to brush"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙la̱h"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "gap"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "space between"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙la̱h"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "gap"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "space between"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙lua̱i, c˙lua̱i-ea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to swim"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙naaw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "finger"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙nah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "pliers, pincers"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙phaa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to divide"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙phaa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "pants, trousers"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙taa̱q"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to tremble, to shake"
		engInfo: "As a machine that is shaking, or person that is shaking."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙taeq-gup"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to tremble, to shake"
		engInfo: "Only used for people. As when you are afraid or cold"
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙toa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "bridge"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "to bridge across"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙toa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "bridge"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "to bridge across"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cavaai"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "leader, chief, boss, supervisor"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mēē"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "leader, chief, boss, supervisor"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cavaai-khaet"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "provincial governor or leader"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cavaai-srok"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "district chief, district governor"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "caai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to spend"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "caaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to wait (for)"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "caaŋ-vaaŋ"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "director , manager"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "caeq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to put"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to place"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to deposit"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "caeq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to put"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to place"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to deposit"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "caeq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to put"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to place"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to deposit"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "caa̱q"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "mountain, hill"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ca̱i-da̱i"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "stupa, chedi, tapering monument"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cap"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "strong"
		engInfo: ""
		engUse: "adjective"
		---
		engWord: "to catch"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cap"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "strong"
		engInfo: ""
		engUse: "adjective"
		---
		engWord: "to catch"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙cap-k˙goo (cap-k˙goo)"
	wordIpa: "In speech is commonly said (cap-k˙goo)"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be happy"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cap-p˙daa̱m"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to begin"
		engInfo: ""
		engUse: "transitive verb, modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cōh"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "and what about ... ?"
		engInfo: ""
		engUse: "interjection"
		---
		engWord: "and how about ... ?"
		engInfo: ""
		engUse: "interjection"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cōh"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "and what about ... ?"
		engInfo: ""
		engUse: "interjection"
		---
		engWord: "and how about ... ?"
		engInfo: ""
		engUse: "interjection"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙baih-tae"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "probably, likely to"
		engInfo: ""
		engUse: "auxiliary"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cem, p̱inataŋ"
	wordIpa: "p̱inataŋ is orrowed from Malay"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "animal"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cem-ŋiuq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "sparrow, ricebird"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "chia̱p"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "immediately"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cha̱iq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to sew"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "choŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "wrong, different"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "chong ṯ˙qawq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be different"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ciw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a woven mat"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ca̱ih-s˙aat"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "clean"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "neat"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "attractive"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ca̱ih-s˙aat"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "clean"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "neat"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "attractive"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ca̱ih-s˙aat"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "clean"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "neat"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "attractive"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "coic"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to click, to press"
		engInfo: "As with a button"
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cok"
	wordIpa: "coc"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to plug, to stop"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to have a strong pain"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cok"
	wordIpa: "coc"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to plug, to stop"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to have a strong pain"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cok-tean"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to have stomach pains / cramps"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "comlaq"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "carving, sculpture"
		engInfo: "Traditional paintings and scultputres done on temple walls"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "comlaik"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "strange, different"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "comnaik"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a part, a piece, a share"
		engInfo: "When a cow is killed for eating, they divide it in parts to be distributed among families"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "comnaik + SUBJECT + vūq"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "as for, on the part of"
		engInfo: "When followed by a subject like (hlīn»"
		engUse: "preposition"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "com-ŋaai"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "distance"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "coŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "spoon"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cong-pha̱u̱"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a cook, a cheff"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cong-sōōm"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "fork"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cōo"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "thief"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ca̱a̱, ca̱a̱-ka̱q"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to wash (the hair)"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to shampoo"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ca̱a̱, ca̱a̱-ka̱q"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to wash (the hair)"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to shampoo"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "t˙ca̱a̱ (ca̱a̱)"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "grandchild"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cōōt"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to park, to moor (a ship)"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "cōp"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to complete, get to the end"
		engInfo: "as when finishing a movie"
		engUse: "completive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "couk"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to put on, to wear"
		engInfo: "To describe the act of putting on clothes above the waist such as shirts, or full body dress or robe"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "daai"
	wordIpa: "must be preceeded by an adjective"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "too _____, excessively"
		engInfo: "As when ssomething is too big."
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "dael"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to have ever"
		engInfo: ""
		engUse: "auxiliary, modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "dael-oo"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to have never"
		engInfo: ""
		engUse: "auxiliary, modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ṯ˙gah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be early, to be fast, to be rapid"
		engInfo: "As when asking someone to come early to an appointment"
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ṯ˙gap"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "thing"
		engInfo: ""
		engUse: "nounm"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ṯ˙gap-aa̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "posession(s), belongings"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ṯ˙gap-aa̱ hlīn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "posession(s)"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱aq h˙līn (p̱a˙līn)"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "my, mine"
		engInfo: ""
		engUse: "preposition, pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "diploom"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "secondary diploma"
		engInfo: "Received when finishing high-school"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ba˙do̱p"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "University Diploma"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "da̱i-sa̱a̱"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "Chalk"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "da̱iq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to climb"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "da̱ih"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to sleep"
		engInfo: ""
		engUse: "intransitive verb"
		---
		engWord: "to lay down"
		engInfo: ""
		engUse: "intransitive verb"
		---
		engWord: "to recline"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "da̱ih"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to sleep"
		engInfo: ""
		engUse: "intransitive verb"
		---
		engWord: "to lay down"
		engInfo: ""
		engUse: "intransitive verb"
		---
		engWord: "to recline"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "da̱ih"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to sleep"
		engInfo: ""
		engUse: "intransitive verb"
		---
		engWord: "to lay down"
		engInfo: ""
		engUse: "intransitive verb"
		---
		engWord: "to recline"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "da̱ih vaa̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to fall asleep"
		engInfo: ""
		engUse: "completive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "da̱ih vaa̱ oo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be unable to sleep, to be sleepless"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "da̱ih pet"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to stay in the hospital"
		engInfo: ""
		engUse: "verb phrase"
		---
		engWord: "to be hospitalized"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "da̱ih pet"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to stay in the hospital"
		engInfo: ""
		engUse: "verb phrase"
		---
		engWord: "to be hospitalized"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "da̱iq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to mount, to ride"
		engInfo: "»To ride a horse», «To ride a bike»"
		engUse: "transitive verb"
		---
		engWord: "to climb"
		engInfo: "»To climb the house»"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "da̱iq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to mount, to ride"
		engInfo: "»To ride a horse», «To ride a bike»"
		engUse: "transitive verb"
		---
		engWord: "to climb"
		engInfo: "»To climb the house»"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "jaoq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "correct"
		engInfo: ""
		engUse: "adjective"
		---
		engWord: "to cut oneself"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "jaoq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "correct"
		engInfo: ""
		engUse: "adjective"
		---
		engWord: "to cut oneself"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "jaoq p˙guq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "need"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "need to use"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "jaoq p˙guq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "need"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "need to use"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "da̱oq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to request"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to ask for"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "da̱oq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to request"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to ask for"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "dōmbōn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "area, region, sector, zone"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙tāā-p˙tāa̱"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to admonish, to instill good behavior"
		engInfo: "As when a parent talks to a child when they do something wrong."
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱oh-p˙nuiq p˙tāā-p˙tāa̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "word of admonition"
		engInfo: "As when a parent talks to a child when they do something wrong."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: "dōmboo̱-n˙mia̱n"
		khUse: ""
		]
	---
	wordCham: "ṯooq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "progressive particle"
		engInfo: "Like using «ing» in english"
		engUse: "particle"
		---
		engWord: "to be (located) at/on, to stay"
		engInfo: "As when saying «He is at home.»"
		engUse: "verb"
		---
		engWord: "to have left , to have left over"
		engInfo: "I have 1000 ria̱l left."
		engUse: "verb"
		---
		engWord: "not yet"
		engInfo: "As when responding to the question: «Are you ready?» Response «ṯooq»"
		engUse: "phrase"
		]
	khArray: [
		khWord: ""
		khInfo: "nou̱, or kompuŋ"
		khUse: ""
		]
	---
	wordCham: "ṯooq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "progressive particle"
		engInfo: "Like using «ing» in english"
		engUse: "particle"
		---
		engWord: "to be (located) at/on, to stay"
		engInfo: "As when saying «He is at home.»"
		engUse: "verb"
		---
		engWord: "to have left , to have left over"
		engInfo: "I have 1000 ria̱l left."
		engUse: "verb"
		---
		engWord: "not yet"
		engInfo: "As when responding to the question: «Are you ready?» Response «ṯooq»"
		engUse: "phrase"
		]
	khArray: [
		khWord: ""
		khInfo: "nou̱, or kompuŋ"
		khUse: ""
		]
	---
	wordCham: "ṯooq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "progressive particle"
		engInfo: "Like using «ing» in english"
		engUse: "particle"
		---
		engWord: "to be (located) at/on, to stay"
		engInfo: "As when saying «He is at home.»"
		engUse: "verb"
		---
		engWord: "to have left , to have left over"
		engInfo: "I have 1000 ria̱l left."
		engUse: "verb"
		---
		engWord: "not yet"
		engInfo: "As when responding to the question: «Are you ready?» Response «ṯooq»"
		engUse: "phrase"
		]
	khArray: [
		khWord: ""
		khInfo: "nou̱, or kompuŋ"
		khUse: ""
		]
	---
	wordCham: "ṯooq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "progressive particle"
		engInfo: "Like using «ing» in english"
		engUse: "particle"
		---
		engWord: "to be (located) at/on, to stay"
		engInfo: "As when saying «He is at home.»"
		engUse: "verb"
		---
		engWord: "to have left , to have left over"
		engInfo: "I have 1000 ria̱l left."
		engUse: "verb"
		---
		engWord: "not yet"
		engInfo: "As when responding to the question: «Are you ready?» Response «ṯooq»"
		engUse: "phrase"
		]
	khArray: [
		khWord: ""
		khInfo: "nou̱, or kompuŋ"
		khUse: ""
		]
	---
	wordCham: "da̱k"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "To carry, haul, transport"
		engInfo: "Only to say the transport of things, not people."
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "da̱k-nōm. da̱k-nōa̱m"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to lead, to guide"
		engInfo: "As a governor to a nation."
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "dua̱iq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to run"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ea-p̱eai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "soup, porridge"
		engInfo: "All kinds of soup, often highly seasoned and containing meat or fish."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ea-p̱eai masam"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "sour soup"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ea-p̱lean"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "moon"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ia̱k"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to see,to look at,"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to read"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ia̱k"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to see,to look at,"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to read"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ia̱k naw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "perhaps, maybe"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ia̱w"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to call"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to be called"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: "hau̱"
		khUse: ""
		]
	---
	wordCham: "ia̱w"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to call"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to be called"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: "hau̱"
		khUse: ""
		]
	---
	wordCham: "ia̱w-qeq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "what is ___ called?"
		engInfo: "For asking what is something called?"
		engUse: "interrogative phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "faamesi"
	wordIpa: "saŋ-pet (doctor˙s house) is more commonly used in the villages where medicine is purchased at the doctor˙s home pharmacy."
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "phramacy"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "g˙nii"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "now, right now"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "also, as well, too"
		engInfo: ""
		engUse: "adverb"
		---
		engWord: "nevertheless"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: "dae"
		khUse: ""
		]
	---
	wordCham: "gaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "also, as well, too"
		engInfo: ""
		engUse: "adverb"
		---
		engWord: "nevertheless"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: "dae"
		khUse: ""
		]
	---
	wordCham: "gae"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "question particle"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "geaw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to wash (a surface)"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "geah"
	wordIpa: "Not a commonly used word"
	wordReviewed: false
	wordNotes: "synonyms: munuih"
	engArray: [
		engWord: "people, population"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: "p˙c̱ia̱-c̱o̱n"
		khUse: ""
		]
	---
	wordCham: "geaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to bloom"
		engInfo: ""
		engUse: "intransitive verb"
		---
		engWord: "to expand"
		engInfo: ""
		engUse: "intransitive verb"
		---
		engWord: "to boil"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "geaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to bloom"
		engInfo: ""
		engUse: "intransitive verb"
		---
		engWord: "to expand"
		engInfo: ""
		engUse: "intransitive verb"
		---
		engWord: "to boil"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "geaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to bloom"
		engInfo: ""
		engUse: "intransitive verb"
		---
		engWord: "to expand"
		engInfo: ""
		engUse: "intransitive verb"
		---
		engWord: "to boil"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gean"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be brave"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "geaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "he, she, they"
		engInfo: ""
		engUse: "pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: "keī"
		khUse: ""
		]
	---
	wordCham: "geaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "he, she, they"
		engInfo: ""
		engUse: "pronoun"
		---
		engWord: "person "
		engInfo: "only when enumerating as in «one person, two people, etc...»"
		engUse: "specifier"
		]
	khArray: [
		khWord: ""
		khInfo: "keī, neak"
		khUse: ""
		]
	---
	wordCham: "geaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "he, she, they"
		engInfo: ""
		engUse: "pronoun"
		---
		engWord: "person "
		engInfo: "only when enumerating as in «one person, two people, etc...»"
		engUse: "specifier"
		]
	khArray: [
		khWord: ""
		khInfo: "keī, neak"
		khUse: ""
		]
	---
	wordCham: "geaŋ dua̱iq-gaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "post man"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "geaŋ bomgaa̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "waiter"
		engInfo: "The waiter at the restaurant"
		engUse: "noun"
		---
		engWord: "servant"
		engInfo: "Someone hired to help with house duties"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "geaŋ bomgaa̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "waiter"
		engInfo: "The waiter at the restaurant"
		engUse: "noun"
		---
		engWord: "servant"
		engInfo: "Someone hired to help with house duties"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "geaŋ domnaa̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "passenger, traveler"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "geaŋ goaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "patient, sick person"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "geaŋ hma̱u̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "village people"
		engInfo: "Literally meaning rice farm people. Usually a term used to refer to the disadvantaged and poor."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "geaŋ kroŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "city people"
		engInfo: "People that live in the city and tend to have better incomes."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "geaŋ c̱eq khea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "neighbor"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "geaŋ ŋaq hma̱u̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "rice farmer, rice farm worker"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "geaŋ dua̱iq taksi"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "taxi driver"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ganam (g˙nam)"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to love"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "g˙nam qaoq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to love (one-another, eachother)"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gūūq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "grass, hay"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gūūq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "grass, hay"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gūūŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "problem, matter"
		engInfo: "As when asking «what is the matter?»"
		engUse: "noun"
		---
		engWord: "plot, subject matter, story, theme"
		engInfo: "As when discussing the matter or plot of a movie"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gūūŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "problem, matter"
		engInfo: "As when asking «what is the matter?»"
		engUse: "noun"
		---
		engWord: "plot, subject matter, story, theme"
		engInfo: "As when discussing the matter or plot of a movie"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gūūŋ k˙phlaiŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "comedy (theme)"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gūūŋ m˙sgouh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "action, war (theme)"
		engInfo: "As in action films, or war films"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gia̱l"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "Cambodian ria̱l (currency)"
		engInfo: ""
		engUse: "specifier, noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gia̱p-cōm"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to prepare, to get ready"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to manage, to organize"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gia̱p-cōm"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to prepare, to get ready"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to manage, to organize"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ga̱l "
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "every (in succesion)"
		engInfo: "LIke when saying «every day»"
		engUse: "preposition"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ga̱l-ga̱l"
	wordIpa: "stronger than saying «ga̱l»"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "every (in totality), each-and-every"
		engInfo: "LIke when saying «every child» or «each and every child»"
		engUse: "preposition"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ga̱l-hgaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "every day"
		engInfo: ""
		engUse: "phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ga̱l-hgaai-nii"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "at the present time, these days"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gīt tae"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "increasingly"
		engInfo: ""
		engUse: "auxiliary"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qeai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "handle"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qeai-nooŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a carrying-pole"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah nua̱q t˙ŋīn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the right hand side"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah nua̱q"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "right side"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "to the right of"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah nua̱q"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "right side"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "to the right of"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah iw t˙ŋīn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the left hand side"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah iw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "left side"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "to the left of"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah iw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "left side"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "to the left of"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah ka˙kouq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the south"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah lea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "below, downstairs"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "beneath of"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah lea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "below, downstairs"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "beneath of"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah nauq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the front"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "in front of"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah nauq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the front"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "in front of"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah ŋoq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the east"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "on top of, above"
		engInfo: ""
		engUse: "adjectival verb"
		---
		engWord: "above, upstairs"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah ŋoq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the east"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "on top of, above"
		engInfo: ""
		engUse: "adjectival verb"
		---
		engWord: "above, upstairs"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah ŋoq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the east"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "on top of, above"
		engInfo: ""
		engUse: "adjectival verb"
		---
		engWord: "above, upstairs"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah ni"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "this side, here, this way"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah tāāq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the back"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "in the back of"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah tāāq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the back"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "in the back of"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah yooq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the west"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qah pouh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "broom"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qeai-c˙gah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "brush"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙gah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to brush"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qeai-c˙gah t˙qaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "toothbrush"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qam"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to stick to, to attach to"
		engInfo: ""
		engUse: "interjection, verb"
		---
		engWord: "to pass (an examination)"
		engInfo: ""
		engUse: "completive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qam"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to stick to, to attach to"
		engInfo: ""
		engUse: "interjection, verb"
		---
		engWord: "to pass (an examination)"
		engInfo: ""
		engUse: "completive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qam-chna̱ot"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to win an election"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qam-qam"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "frequently, often"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qauq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "together"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qeq hoaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "food"
		engInfo: "Everything you eat with rice"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qeq hoaq l˙peh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "left-over food"
		engInfo: "Often used to describe scraps that is given to animals, or thrown away as many in the village do not have refridgerators."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qeq-qeq, qeq-qaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "things, provisions, luggage"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qīn-tae"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "only, just"
		engInfo: ""
		engUse: "auxiliary"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qīt"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "he,she, they (genderless singular)"
		engInfo: "A respectiful pronoun"
		engUse: "pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qiiŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "stove"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qleai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "forest, jungle"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qnooŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "angry"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qrua̱h-thnaq"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "accident, danger"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qu-peet"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "doctor"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "quu"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "Teacher"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "... qua̱n laai ?"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "at what time ... ?"
		engInfo: "Question asking for a general time such as (morning, afternoon, evening, etc.), but a specific time can be provided in response."
		engUse: "interrogative phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qul"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "round, circular, cylindrical"
		engInfo: ""
		engUse: "adjectival"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qua̱n"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "time"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qua̱n-malam"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "at night time"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qua̱n-suup"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "morning"
		engInfo: "any time before noon"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "qlooŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "high, tall"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "goaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to have illness, to have a disease"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: "cumŋuu"
		khUse: ""
		]
	---
	wordCham: "goaq-caɲ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to have malaria"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "goaq caɲ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "malaria"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "goaq-mua̱l"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to have dysentery"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "goaq-p˙deaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to have a fever"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "goah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to choose, select, appoint, to pick out"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "Honorific title for deceased person"
		engInfo: ""
		engUse: "noun, title"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "goah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to choose, select, appoint, to pick out"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "Honorific title for deceased person"
		engInfo: ""
		engUse: "noun, title"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gōō"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "fast"
		engInfo: "moving or capable of moving at a high speed, such as a car, or bird"
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "goo̱q"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to dig"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gōōŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to support, to maintain, to raise"
		engInfo: "In the sense of supoorting life, such as when raising children or animals."
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: "ceɲ"
		khUse: ""
		]
	---
	wordCham: "gōōŋ-ca̱m"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to raise animals, keep animals"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: "ceɲca̱m-sīt"
		khUse: ""
		]
	---
	wordCham: "gōōŋ-gup"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to support one-self, to make a living"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: "ceɲca̱m-sīt"
		khUse: ""
		]
	---
	wordCham: "gooŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "shed, gazebo"
		engInfo: "Used for shade in the farms, if used with another word, it takes the meaning of hall, barn, or plant"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gooŋ-caq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "factory, industrial plant, industry"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gooŋ-kon"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "cinema, movie theater"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gooŋ m˙sīn k˙geq-k˙yaw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "saw mill"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gooŋ-caq p˙kaw-jouq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "cigarrette factory"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gup"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "body"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙p̱ia̱n-lai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "when, whenever"
		engInfo: ""
		engUse: "conjunction"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙gaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "day"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-baŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "one time, once"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-qeq (qeq)"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "what?"
		engInfo: ""
		engUse: "interrogative pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-qeq mnu̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "what things?"
		engInfo: "Expecting a plural answer"
		engUse: "interrogative pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-m˙ta̱u̱h"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "one half, half"
		engInfo: ""
		engUse: "noun, numeraal"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "haa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to open the mouth"
		engInfo: "only for the mouth"
		engUse: "transitive verb"
		---
		engWord: "cake"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "haa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to open the mouth"
		engInfo: "only for the mouth"
		engUse: "transitive verb"
		---
		engWord: "cake"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "haapih (pih)"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to run out, to exhaust"
		engInfo: ""
		engUse: "verb"
		---
		engWord: "cake"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: "a̱h"
		khUse: ""
		]
	---
	wordCham: "haapih (pih)"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to run out, to exhaust"
		engInfo: ""
		engUse: "verb"
		---
		engWord: "cake"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: "a̱h"
		khUse: ""
		]
	---
	wordCham: "haai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "too, also, in addition to"
		engInfo: "Like when pleading «I want to eat too»"
		engUse: "adverb, final particle"
		---
		engWord: "among (other things)"
		engInfo: "As when saying «I˙m busy tomorrow, because I have to wash my car, among, having to go to the bank». I implies that you˙re busy."
		engUse: "final particle"
		---
		engWord: "someone, anyone, whoever"
		engInfo: ""
		engUse: "pronoun"
		---
		engWord: "who"
		engInfo: ""
		engUse: "interrogative pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: "daē"
		khUse: ""
		]
	---
	wordCham: "haai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "too, also, in addition to"
		engInfo: "Like when pleading «I want to eat too»"
		engUse: "adverb, final particle"
		---
		engWord: "among (other things)"
		engInfo: "As when saying «I˙m busy tomorrow, because I have to wash my car, among, having to go to the bank». I implies that you˙re busy."
		engUse: "final particle"
		---
		engWord: "someone, anyone, whoever"
		engInfo: ""
		engUse: "pronoun"
		---
		engWord: "who"
		engInfo: ""
		engUse: "interrogative pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: "daē"
		khUse: ""
		]
	---
	wordCham: "haai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "too, also, in addition to"
		engInfo: "Like when pleading «I want to eat too»"
		engUse: "adverb, final particle"
		---
		engWord: "among (other things)"
		engInfo: "As when saying «I˙m busy tomorrow, because I have to wash my car, among, having to go to the bank». I implies that you˙re busy."
		engUse: "final particle"
		---
		engWord: "someone, anyone, whoever"
		engInfo: ""
		engUse: "pronoun"
		---
		engWord: "who"
		engInfo: ""
		engUse: "interrogative pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: "daē"
		khUse: ""
		]
	---
	wordCham: "haai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "too, also, in addition to"
		engInfo: "Like when pleading «I want to eat too»"
		engUse: "adverb, final particle"
		---
		engWord: "among (other things)"
		engInfo: "As when saying «I˙m busy tomorrow, because I have to wash my car, among, having to go to the bank». I implies that you˙re busy."
		engUse: "final particle"
		---
		engWord: "someone, anyone, whoever"
		engInfo: ""
		engUse: "pronoun"
		---
		engWord: "who"
		engInfo: ""
		engUse: "interrogative pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: "daē"
		khUse: ""
		]
	---
	wordCham: "geaŋ lai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: "haai"
	engArray: [
		engWord: "who"
		engInfo: ""
		engUse: "interrogative pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "haaŋ"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "shop"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "haaŋ"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "shop, store"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "haaŋ ckauq-bouq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "barber shop"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "haaŋ-l˙saai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "restaurant"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "saaŋ-tumnak"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "guest house"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-geaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "one person"
		engInfo: ""
		engUse: "numeral, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-l˙paw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "one thousand"
		engInfo: ""
		engUse: "numeral"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-pleet"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "awhile, for awhile"
		engInfo: ""
		engUse: "noun, adverb"
		---
		engWord: "a moment, for a moment"
		engInfo: ""
		engUse: "noun, adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-pleet"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "awhile, for awhile"
		engInfo: ""
		engUse: "noun, adverb"
		---
		engWord: "a moment, for a moment"
		engInfo: ""
		engUse: "noun, adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-plou̱h-laksaa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "one hundred thousand"
		engInfo: ""
		engUse: "numeral"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-plou̱h-l˙mu̱u̱ (l˙ma̱u̱)"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "fifteen"
		engInfo: ""
		engUse: "numeral"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-plou̱h-nam"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "sixteen"
		engInfo: ""
		engUse: "numeral"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-plou̱h-saa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "eleven"
		engInfo: ""
		engUse: "numeral"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-plou̱h-ṯoa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "twelve"
		engInfo: ""
		engUse: "numeral"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-sit"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "some, a little"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-sit"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "some, a little"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha-sit ha-s˙gaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "not very much"
		engInfo: "As in «I don˙t have very much money»"
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hat"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to practice, drill"
		engInfo: ""
		engUse: "modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hat aan"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to practice reading"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "haṯaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "after"
		engInfo: ""
		engUse: "preposition"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "haṯaai moŋ non"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "after that"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "haṯoom"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "how much?"
		engInfo: ""
		engUse: "interrogative pronoun"
		---
		engWord: "how many?"
		engInfo: ""
		engUse: "interrogative pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "haṯoom"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "how much?"
		engInfo: ""
		engUse: "interrogative pronoun"
		---
		engWord: "how many?"
		engInfo: ""
		engUse: "interrogative pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙gaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a note, a letter, a ticket"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "to write"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙gaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a note, a letter, a ticket"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "to write"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙gaq kapal"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "boat ticket"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "poh-gōoh (hgōoh)"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "letters, alphabet, writing system"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙laa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "leaf"
		engInfo: "As in «tree leaf»"
		engUse: "noun, specifier"
		---
		engWord: "sheet"
		engInfo: "As in «sheet of paper»"
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙laa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "leaf"
		engInfo: "As in «tree leaf»"
		engUse: "noun, specifier"
		---
		engWord: "sheet"
		engInfo: "As in «sheet of paper»"
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hooq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "yes"
		engInfo: "Can be used as an exclamation, or a polite response"
		engUse: "exclamation, response"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙laa-tna̱ot"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "sugar palm leaf"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hlīn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "I, me, my"
		engInfo: ""
		engUse: "pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙la̱ih"
	wordIpa: "Old pronunciation (sla̱ih)"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to change"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to trade"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to replace"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to move to (to a new home)"
		engInfo: "As in «To move to a new house». Ex. h˙la̱ih saaŋ = moved to a new house"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙la̱ih"
	wordIpa: "Old pronunciation (sla̱ih)"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to change"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to trade"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to replace"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to move to (to a new home)"
		engInfo: "As in «To move to a new house». Ex. h˙la̱ih saaŋ = moved to a new house"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙la̱ih"
	wordIpa: "Old pronunciation (sla̱ih)"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to change"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to trade"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to replace"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to move to (to a new home)"
		engInfo: "As in «To move to a new house». Ex. h˙la̱ih saaŋ = moved to a new house"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙la̱ih"
	wordIpa: "Old pronunciation (sla̱ih)"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to change"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to trade"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to replace"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to move to (to a new home)"
		engInfo: "As in «To move to a new house». Ex. h˙la̱ih saaŋ = moved to a new house"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙la̱ih"
	wordIpa: "Old pronunciation (sla̱ih)"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to change"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to trade"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to replace"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to move to (to a new home)"
		engInfo: "As in «To move to a new house». Ex. h˙la̱ih saaŋ = moved to a new house"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙la̱ih"
	wordIpa: "Old pronunciation (sla̱ih)"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to change"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to trade"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to replace"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to move to (to a new home)"
		engInfo: "As in «To move to a new house». Ex. h˙la̱ih saaŋ = moved to a new house"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙la̱ih"
	wordIpa: "Old pronunciation (sla̱ih)"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to change"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to trade"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to replace"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to move to (to a new home)"
		engInfo: "As in «To move to a new house». Ex. h˙la̱ih saaŋ = moved to a new house"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙la̱ih"
	wordIpa: "Old pronunciation (sla̱ih)"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to change"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to trade"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to replace"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to move to (to a new home)"
		engInfo: "As in «To move to a new house». Ex. h˙la̱ih saaŋ = moved to a new house"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hlouq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "ground, earth"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ṯunyea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "world"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hluaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be sharp, to be pointy"
		engInfo: "Can be used to describe a knife, or the tip of a pen"
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hluy"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "shade"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hmīt"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to hear a sound"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hma̱u̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "rice field"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hma̱u̱ p̱lean cean"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "rainy season rice crop"
		engInfo: "There are two rice crops each year in Cambodia. The rainy season crop is spoken literally as «the rain month rice field»"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hma̱u̱ p̱lean phaaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "dry season rice crop"
		engInfo: "There are two rice crops each year in Cambodia. The rainy season crop is spoken literally as «the dry month rice field»"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hma̱u̱ p̱lean phaaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "dry season rice crop"
		engInfo: "There are two rice crops each year in Cambodia. The rainy season crop is spoken literally as «the dry month rice field»"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hnaa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be difficult"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hnaa taai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "unhappy"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hnua̱q"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "right side"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hoa̱q l˙saai (hoa̱q)"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to eat (rice only)"
		engInfo: "Only used for eating rice"
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "haai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "who"
		engInfo: ""
		engUse: "interogative pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "haai-haai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "whoever, anyone, someone"
		engInfo: ""
		engUse: "interogative pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "haŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "hot, spicy"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hoŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "and, with, along with"
		engInfo: ""
		engUse: "preposition"
		---
		engWord: "with"
		engInfo: ""
		engUse: "conjunction"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hoŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "and, with, along with"
		engInfo: ""
		engUse: "preposition"
		---
		engWord: "with"
		engInfo: ""
		engUse: "conjunction"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hoŋ-qaoq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "together, with each other"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "s˙gae"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to flow, to drip"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "duic"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to run"
		engInfo: "when used with animals and people"
		engUse: "intransitive verb"
		---
		engWord: "to flow, to run"
		engInfo: "when used with water"
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "duic"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to run"
		engInfo: "when used with animals and people"
		engUse: "intransitive verb"
		---
		engWord: "to flow, to run"
		engInfo: "when used with water"
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "how"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to have, to get, to obtain"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to be able to"
		engInfo: ""
		engUse: "completive verb"
		---
		engWord: "to have (done something)"
		engInfo: ""
		engUse: "modal verb"
		---
		engWord: "to exist"
		engInfo: ""
		engUse: "modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "how"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to have, to get, to obtain"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to be able to"
		engInfo: ""
		engUse: "completive verb"
		---
		engWord: "to have (done something)"
		engInfo: ""
		engUse: "modal verb"
		---
		engWord: "to exist"
		engInfo: ""
		engUse: "modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "how"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to have, to get, to obtain"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to be able to"
		engInfo: ""
		engUse: "completive verb"
		---
		engWord: "to have (done something)"
		engInfo: ""
		engUse: "modal verb"
		---
		engWord: "to exist"
		engInfo: ""
		engUse: "modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "how"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to have, to get, to obtain"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to be able to"
		engInfo: ""
		engUse: "completive verb"
		---
		engWord: "to have (done something)"
		engInfo: ""
		engUse: "modal verb"
		---
		engWord: "to exist"
		engInfo: ""
		engUse: "modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "how-caaŋ-oo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to have no need"
		engInfo: ""
		engUse: "verb phrase"
		---
		engWord: "to be unnecessary"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "how-caaŋ-oo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to have no need"
		engInfo: ""
		engUse: "verb phrase"
		---
		engWord: "to be unnecessary"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "how-qeq-oo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "Don˙t mention it, It˙s nothing, you˙re welcome"
		engInfo: ""
		engUse: "idiom"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "how-kaa ... oo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "not yet ..."
		engInfo: "Verb must be placed between «how-kaa» and «oo»"
		engUse: "auxuliary"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "how-sa̱u̱ ... oo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "hardly, not very ..."
		engInfo: "Verb must be placed between «how-sa̱u̱» and «oo»"
		engUse: "auxuliary"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "how-tae"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "only, exept, solely"
		engInfo: ""
		engUse: "auxuliary"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "jaoq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be correct, to be true"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha̱u̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "you, yourself"
		engInfo: "Not a polite word. But used among close friends. Becareful with use."
		engUse: "pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kaw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "I, myself"
		engInfo: "Not a polite word. But used among close friends. Becareful with use."
		engUse: "pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hua̱iq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be afraid of"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hua̱iq-tae ..."
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be afraid that ..., to be worried about ..."
		engInfo: ""
		engUse: "transitive verb, modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ha̱p"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "trunk, suitcase, chest"
		engInfo: "Usually a wooden container used for storage"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "iaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to look, to observe"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "iw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "left"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "iw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "left"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "j˙man"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "toilet, bathroom"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ceam"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "plate, dish"
		engInfo: ""
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱˙luq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "plate, dish"
		engInfo: ""
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙ɲīn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a small bowl"
		engInfo: "Usually used for dipping sauces, or snacks"
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱ean"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "rain"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱eaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "more-than"
		engInfo: ""
		engUse: "preposition"
		---
		engWord: "worker, skilled laborer, artisan"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱eaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "more-than"
		engInfo: ""
		engUse: "preposition"
		---
		engWord: "worker, skilled laborer, artisan"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱eaŋ-geaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the most, most of all"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱eaŋ-kayaw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "carpenter"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱eaw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "green"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱˙lean"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "way, route, street, road"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱˙lean-ea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "waterway"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱˙lean-l˙teh-pui"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "railroad"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱˙lean-p˙baiq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "intersection"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱muq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "mosquito"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱aŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to cover, to veil, to mask"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "taoq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to hide, to conceal"
		engInfo: "The act of hiding onself or something"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱˙vop (ch˙laa̱i)"
	wordIpa: "(Khmer word) is more commonly used."
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to answer"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱eq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "near, nearly, almost"
		engInfo: "Can be used for both place and time"
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱eq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "near, nearly, almost"
		engInfo: "Can be used for both place and time"
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱ia̱-daa̱m"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "just like, such as, same as"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱ēeh, hgōōq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to insert, to put through"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱ēeh, hgōōq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to insert, to put through, to put in"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱˙guh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to shed, drip off, to loosen, to fall off, to slip off"
		engInfo: "for example: «fruits falls from the tree», or «Money slips off your pocket»"
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱˙guŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "corner"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "jam"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "vegetable"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "jouq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to smoke, to suck, to inhale"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "jua̱l"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "light (in weight)"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱iet"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "taste, flavor"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙bui-ba̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the bank of a lake"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱oa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "quiet, peaceful"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱oh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to break (something long), to snap"
		engInfo: "Used to describe the breakin gof long object"
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱oh-lee"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to break a leg"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱omnon"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to flood"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱omnua̱ɲ"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "commerce, business"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱ōn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "floor, level, stage, deck"
		engInfo: ""
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱oo-lup"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "eraser"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱uun"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to accompany, to join"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱ua̱h-c̱ul"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to repair"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱ua̱n-kaal"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "sometimes"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱ua̱p-c̱um"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to meet together, to convene"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱um-nuan"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "number, total, quantity"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱umnu̱a̱"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "number, total, quantity"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱ia̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to believe"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱uŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "end point"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱a̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be able"
		engInfo: ""
		engUse: "completive verb"
		---
		engWord: "to give birth to, to be born, to happen, to arise"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to get, to develop (a diesase or condition)"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to succeed"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱a̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be able"
		engInfo: ""
		engUse: "completive verb"
		---
		engWord: "to give birth to, to be born, to happen, to arise"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to get, to develop (a diesase or condition)"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to succeed"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱a̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be able"
		engInfo: ""
		engUse: "completive verb"
		---
		engWord: "to give birth to, to be born, to happen, to arise"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to get, to develop (a diesase or condition)"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to succeed"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱a̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be able"
		engInfo: ""
		engUse: "completive verb"
		---
		engWord: "to give birth to, to be born, to happen, to arise"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to get, to develop (a diesase or condition)"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to succeed"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱ua̱i-p̱˙gai (c̱ua̱i)"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "don˙t be, do not, negative imperative"
		engInfo: ""
		engUse: "auxiliary"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱u̱u̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "fertilizer"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙p̱eaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to walk"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙p̱laai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to sell"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱laai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to buy"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙p̱laai-sla̱ih"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to trade, to do commerce"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙p̱ui"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "pig"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙gaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "another, a different"
		engInfo: ""
		engUse: "determiner"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙gaai-k˙gaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "many others, other ones"
		engInfo: ""
		engUse: "determiner"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "chōŋ ṯi-qaoq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be different"
		engInfo: ""
		engUse: "phrasal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙gu̱u̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "thing, part, accessory"
		engInfo: ""
		engUse: "noun, specifier"
		---
		engWord: "ingredients, spices"
		engInfo: "To specify parts of a meal"
		engUse: "noun, specifier"
		---
		engWord: "ingredients, spices"
		engInfo: "To specify parts of a meal"
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙gu̱u̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "thing, part, accessory"
		engInfo: ""
		engUse: "noun, specifier"
		---
		engWord: "ingredients, spices"
		engInfo: "To specify parts of a meal"
		engUse: "noun, specifier"
		---
		engWord: "ingredients, spices"
		engInfo: "To specify parts of a meal"
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙gu̱u̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "thing, part, accessory"
		engInfo: ""
		engUse: "noun, specifier"
		---
		engWord: "ingredients, spices"
		engInfo: "To specify parts of a meal"
		engUse: "noun, specifier"
		---
		engWord: "ingredients, spices"
		engInfo: "To specify parts of a meal"
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙gu̱u̱ŋ-tok-tow"
	wordIpa: "»tok-tow» is borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "furniture"
		engInfo: ""
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kru̱a̱ŋ sa̱ŋ-haa-ru̱m"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "wood crafts"
		engInfo: "Normally sold in a shop that makes nothing but wooden objects"
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙gu̱u̱ŋ-tok-tow"
	wordIpa: "»tok-tow» is borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "furniture"
		engInfo: ""
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙gu̱u̱ŋ-lean"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "car parts"
		engInfo: ""
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙gee"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "bed"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙gip"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "jack, lift"
		engInfo: "word is commonly used fro large jacks used to raise houses to higher stilts"
		engUse: "noun, verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "doi"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "jack (for car)"
		engInfo: ""
		engUse: "noun, verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙goo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be well"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙kouh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to greet with palms joined"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "klōq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "bottle"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙mu̱u̱-plouh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "fifty"
		engInfo: ""
		engUse: "numeral"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙ɲaan"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "stairs, ladder"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nu̱q-k˙ɲaan"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "steps (of a ladder)"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙pah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to rent to"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "pah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to rent"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙pak"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "ax, hatchet"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙p̱līt"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to go out, to be extinguished"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙poaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a handful, a bundle"
		engInfo: ""
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙poŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "river bank, river port"
		engInfo: "Used to refer to the area where people bathe or gather water at the river. Usually containing steps or ramp into the river, 	"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙pōōq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to wrap, to swaddle"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙p̱um"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to hold in the mouth"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙p̱uŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "...ing, in the process of"
		engInfo: "As when adding «ing» to a verb, progressive auxiliary"
		engUse: "auxiliary"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙taau"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "king"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "lice"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙taau"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "king"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "lice"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙taau (k˙taau)"
	wordIpa: "Borrowed from Malay"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "stone"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙ṯi"
	wordIpa: "Borrowed from Malay"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "kettle, pot"
		engInfo: "Made from clay or ceramic"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙tgia̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be responsible, to be diligent, to not be lazy"
		engInfo: "opposite of being lazy"
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙ta̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to sink (in water)"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙vat-koo"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a (neck) tie"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙yoa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "because"
		engInfo: ""
		engUse: "conjunction"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to tie"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kaq-t˙ŋīn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to give a gift (to newlyweds)"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kaa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "...first"
		engInfo: "As «i need to eat first»"
		engUse: "final particle"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kaa-pia̱"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to protect, to defend"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kaa-rua̱h-nou̱"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "life, living, existence"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kaaw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "I"
		engInfo: "not-polite to say to someone older, only to address children or those younger than you."
		engUse: "pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kaeq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to bite"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kaeq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to bite"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kēw"
	wordIpa: "Borrowed from khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a glass, a glass (of)"
		engInfo: ""
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kak-se˙kam"
	wordIpa: "Borrowed from khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "agriculture"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kam"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to rake"
		engInfo: ""
		engUse: "noun, transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kam-kōō"
	wordIpa: "Borrowed from khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "workers"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kampucia̱, (kow)"
	wordIpa: "Borrowed from khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "Cambodia"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kan"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be poor"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kan"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be poor"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kan-tae"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "continue to ... more, to increasinly ..."
		engInfo: "As in «I will increasingly age», I will continue to learn more."
		engUse: "auxiliary"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kanot"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "motorized river boats"
		engInfo: "Such as sand carriers"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kee-da̱a̱ (da̱a̱)"
	wordIpa: "Borrowed from khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "water ferry"
		engInfo: "It can carry cards and people acrross the river"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: "tuk-da̱a̱ "
		khUse: ""
		]
	---
	wordCham: "k˙pal-ea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a large ship"
		engInfo: "Referring to intercontinental transport ships used in the sea."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙lai-kapah (k˙pah)"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "cotton"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙pal-hōh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "airplane"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kasaet"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "newspaper"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "casette"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kasaet"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "newspaper"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "casette"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kasow"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "rubber"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙baic"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "design"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙baic-comlaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "sculpture"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙p̱eaq-m˙īn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to stroll (to walk for amusement)"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙bōt"
	wordIpa: "Borrowed from khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to deceive, to betray"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kdaa-khia̱n, tabloo"
	wordIpa: "Borrowed from khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "blackboard"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kda̱i"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "temple"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙da̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be quiet, to be silent"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kīn"
	wordIpa: "Borrowed from khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to thresh, to mill"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙gaai-k˙gaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "various, different"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "khaan"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to fail, to be missing something, to lack"
		engInfo: "Borrowed fro Khmer"
		engUse: "modal verb"
		---
		engWord: "to tell, to inform"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "khaan"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to fail, to be missing something, to lack"
		engInfo: "Borrowed fro Khmer"
		engUse: "modal verb"
		---
		engWord: "to tell, to inform"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "khaet"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "province"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "khan-aaw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "clothes, clothing"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "khan-aaw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "clothes, clothing"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "khan-ŋuy"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "skirt, women˙s clothes"
		engInfo: "Can be used to refer to all female clothing"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "khaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be strong, to be hard, to be tough, to be extreme"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "khīn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to want"
		engInfo: ""
		engUse: "modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "khīn-p˙tgah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to hurry"
		engInfo: ""
		engUse: "modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "khōoŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to steam"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to dry, to dehydrate"
		engInfo: "Always with the use of fire"
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "khōoŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to steam"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "to dry, to dehydrate"
		engInfo: "Always with the use of fire"
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "khum"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "commune"
		engInfo: "A section of a district"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "khuut"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "damaged, spoiled, broken, not functioning properly"
		engInfo: "In the sense of malfunction, or not working properly"
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "khvae"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "coffee"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ka̱i-laa"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "sports, games"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kimi"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "Chemical, Chemistry"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kīn-oo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "is not"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "klaaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to abandon, to throw away, to leave alone"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "klaeq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to steal"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "klam"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "pen"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "klau"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "three"
		engInfo: ""
		engUse: "numeral"
		---
		engWord: "to laugh"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "klau"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "three"
		engInfo: ""
		engUse: "numeral"
		---
		engWord: "to laugh"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "klau-paak"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "three or four"
		engInfo: ""
		engUse: "numeral"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "khlia̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "sentence"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kla̱iq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "skin, leather"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "klōh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to split, to break, "
		engInfo: "Only for strings, or ropelike objects"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "klōh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to split, to break, "
		engInfo: "Only for long objects, like strings or bridges"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kloo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "kilogram"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kloo-hlowk"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "kilometer"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙mua̱n"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "niece, nephew"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kāk"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "head"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kāk-t˙owq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "knee"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kāk-a̱i, c̱uŋ-mea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "chair"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "koa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to comb"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "koah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to shave"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kōh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "island"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "to be very shallow"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kōh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "island"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "to be very shallow"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kōaiq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "orange, citrus fruit"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kom-dāā"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to accompany, to attend (with), to be groomsman or bridesmaid"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "komha̱ŋ"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "anger"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c̱a̱ŋ (komnaa̱t)"
	wordIpa: "Komnaa̱t is borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "birth"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "komphlaeŋ"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "funny, humorous"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "komrīt"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "level, degree, rank, stage"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "komrīt"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "film, movie"
		engInfo: "Usually refering to films played in a theater, or projected large on a wall."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "komrīt"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "film, movie"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kong"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "that, which, who"
		engInfo: "a relative pronoun as in «he that read today»"
		engUse: "pronoun"
		---
		engWord: "wheel, bicycle"
		engInfo: "Borrowed from Khmer"
		engUse: "noun"
		---
		engWord: "account"
		engInfo: "as in «bank account», borrowed from Khmer"
		engUse: "noun"
		---
		engWord: "a piece, or slice (of something long)"
		engInfo: ""
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kong"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "that, which, who"
		engInfo: "a relative pronoun as in «he that read today»"
		engUse: "pronoun"
		---
		engWord: "wheel, bicycle"
		engInfo: "Borrowed from Khmer"
		engUse: "noun"
		---
		engWord: "account"
		engInfo: "as in «bank account», borrowed from Khmer"
		engUse: "noun"
		---
		engWord: "a piece, or slice (of something long)"
		engInfo: ""
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kong"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "that, which, who"
		engInfo: "a relative pronoun as in «he that read today»"
		engUse: "pronoun"
		---
		engWord: "wheel, bicycle"
		engInfo: "Borrowed from Khmer"
		engUse: "noun"
		---
		engWord: "account"
		engInfo: "as in «bank account», borrowed from Khmer"
		engUse: "noun"
		---
		engWord: "a piece, or slice (of something long)"
		engInfo: ""
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kong"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "that, which, who"
		engInfo: "a relative pronoun as in «he that read today»"
		engUse: "pronoun"
		---
		engWord: "wheel, bicycle"
		engInfo: "Borrowed from Khmer"
		engUse: "noun"
		---
		engWord: "account"
		engInfo: "as in «bank account», borrowed from Khmer"
		engUse: "noun"
		---
		engWord: "a piece, or slice (of something long)"
		engInfo: ""
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kong-skuo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "spare wheel, spare tire"
		engInfo: ""
		engUse: "noun phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "c˙daēh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a slice"
		engInfo: ""
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "koo"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "kappok"
		engInfo: "A cotton like substance that grows around the seeds of the ceiba tree"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kow-rup"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to honor, to pay respect to"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kōō-hov"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be acceptable, to be a possibility"
		engInfo: ""
		engUse: "completive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "... kōō-how ... kōō-how"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "either ...  or ... is ok, is a possibility"
		engInfo: ""
		engUse: "completive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kōōk"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "frozen, congealed"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "... kōō-m˙ṯea ... kōō-m˙ṯea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "it can ... or can ..."
		engInfo: "As when saying «it can rain the morning, or it can rain in the evening»"
		engUse: "completive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kōō-saaŋ"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to build, to construct"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kot"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "Monastery"
		engInfo: "Where buddhist monks live."
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kow"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "Cambodian"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kraem-ka̱i"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "ice cream"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kraem-ka̱i"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "ice cream"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "krom"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "group, council"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "krom-hon"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "business, commercial firm"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "krua̱-saa"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "family"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kuu"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "pair"
		engInfo: ""
		engUse: "specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ku"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "should, suitable, appropriate"
		engInfo: "As «you should go back home now»"
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kua̱-p̱˙gaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "makes onself to, moves oneself to, compels onself to, to be worth to, to deserve to be"
		engInfo: "as «that food is appealing to eat», or «that scary movie makes me afraid»"
		engUse: "adjectival verb, modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kua̱-p̱˙gaai khīn-ia̱q"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "appealing to see, worth seeing, interesting"
		engInfo: "As «The movie is worth seeing»"
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kua̱-p̱˙gaai nīt"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to deserve one˙s sympathy or pity"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kua̱-som"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be reasonable, to be moderate, to be sensitive, to be polite"
		engInfo: "When you restrain yourself from something, for the sake of someone else."
		engUse: "verb phrase"
		---
		engWord: "to be somewhat, or moderately"
		engInfo: "As «the food is somewhat hot»"
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kua̱-som"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be reasonable, to be moderate, to be sensitive, to be polite"
		engInfo: "When you restrain yourself from something, for the sake of someone else."
		engUse: "verb phrase"
		---
		engWord: "to be somewhat, or moderately"
		engInfo: "As «the food is somewhat hot»"
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ka̱u̱h"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "middle, center, central"
		engInfo: "As in «the middle of a line, or the center of a circle»"
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kum-noo (k˙noo)"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "pile, stack"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kumnīt"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "thought"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ku̱u̱"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "kuu"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ku̱u̱n"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to know, to be acquainted, to know of"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kuo-tia̱w"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "chinese noodles"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kvīn"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be paralized, to be atrophied, to be disabled"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "kvīn-lee"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a paralized, disabled, or atrophied leg"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙aan"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be cold, to be chilly"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙bah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be in a sad condition, to be miserable, to be destitue"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "k˙ga̱ūq, k˙gūūq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to close"
		engInfo: "As «to close the door» and anything on hinges"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙hiwq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to disappear, to lose"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙huut"
	wordIpa: "Borrowed from khmer "
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "indefinietly, always, all the way, throughout it all"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lakaaw (l˙kaaw)"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "Please"
		engInfo: ""
		engUse: "auxiliary"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙kaaw-maaf"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "Excuse me, I˙m sorry"
		engInfo: ""
		engUse: "interjection"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙kaaw-t˙aa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to politely invite"
		engInfo: "as «Please sit down»"
		engUse: "modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙kaaw-p˙gaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to pray to God, to ask God, to hope in God"
		engInfo: "I pray you heal quickly"
		engUse: "modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙kaaw-lea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to take leave"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "hlin l˙kaaw-lea nēa̱w-vūq yu̱u̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "good bye"
		engInfo: "literally «I say good bye now»"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙khah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to get married"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙lōō"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "meat, flesh"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙lōō-l˙mōō"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "beef, cow meat"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙lōō-kaan"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "fish, fish meat"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙lōō-k˙pua̱i"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "pork, pig meat"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙mōō"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "cow, ox"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙ma̱u̱, l˙mu̱u̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "five"
		engInfo: ""
		engUse: "numeral"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙mu̱u̱-plouh-phea̱q-rooy"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "fifty percent"
		engInfo: ""
		engUse: "numeral, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙mu̱u̱q"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "fat"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "to be fat"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙mu̱u̱q"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "fat"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "to be fat"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙ŋaal"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "plow"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙ŋiw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "outisde"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙ŋiw-moŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "besides, outside of"
		engInfo: ""
		engUse: "preposition"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙oa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to plow"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙ow"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "coconut"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙paa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be hungry (for)"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙paaw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "thousand"
		engInfo: ""
		engUse: "numeral"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙peh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to remain, to be left over"
		engInfo: "As «I have two dollars remaining»"
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙pa̱ih"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be thin"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nu̱u̱q-k˙saēŋ"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "towel, hankerchief"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙pa̱ih-l˙pa̱ih"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "are thin (plural)"
		engInfo: "As «the leaves of the mango tree are thin»"
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙peaŋ, l˙pooŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "hole"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙saai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "cooked rice"
		engInfo: "It also includes food that is eaten with rice"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙sai qua̱n-suup"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "breakfast, morning meal"
		engInfo: "Not commonly used, people normally just refer to eating, without specifying the type of meal."
		engUse: "noun phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙saai-chaa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "fried rice"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙saai-khōoŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "steamed rice"
		engInfo: "The rice is cooked above the water, not in the water."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙sōn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "onion, garlic"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙taaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "bean"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙taaq-hlouq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "peanut"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙ṯeh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "cart"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙ṯeh-pui"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "train"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙tōuh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "hundred"
		engInfo: ""
		engUse: "numeral"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "haa-l˙tōuh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "one hundred"
		engInfo: ""
		engUse: "numeral"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙viq-mea̱i-yu̱u̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "for a long time now"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "... laai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "where ... ?"
		engInfo: ""
		engUse: "interrogative pronoun, interrogative adjective"
		---
		engWord: "any, some, whichever"
		engInfo: ""
		engUse: "indefinite adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "... laai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "where ... ?"
		engInfo: ""
		engUse: "interrogative pronoun, interrogative adjective"
		---
		engWord: "any, some, whichever"
		engInfo: ""
		engUse: "indefinite adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "laaw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to lie, to prevaricate, to beat around the bush"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to lose to, to be deafated"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lahau̱i"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "cool, refreshing"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lean"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "car"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lean-c˙nua̱l"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "taxi van"
		engInfo: "The most common form of mass transmport in cambodia. It˙s usually a mercedes van that will take people and goods to the villages and provinces."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lean-p˙c̱a̱ŋ tomniɲ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "truck, or semia"
		engInfo: "Used for to transporting large loads."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lak"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "alcoholic drink"
		engInfo: "It could be used to refer to any alcoholic drink; wine, beer, etc."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lak-saa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "ten thousand"
		engInfo: "A number specifier for ten-thousand, that is not found in English. It˙s used in the same way we use «hundred» or «thousand»."
		engUse: "numeral"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lakaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "male"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙baeŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "game (of gamling)"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙ba̱u̱-ŋīn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "fame, renown, reputation"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙p-bu̱a̱n"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "speed"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "gōō"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "fast"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙bua̱ih"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "wound"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙teh-l˙mōō"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "ox cart"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lea̱iq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to say, that"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lee"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "foot, leg"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "leik"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "number, figure"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: "thaa"
		khUse: ""
		]
	---
	wordCham: "l˙hōŋ"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "papaya"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "liit"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "liter"
		engInfo: ""
		engUse: "specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lia̱n"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "million"
		engInfo: ""
		engUse: "numeral"
		---
		engWord: "to stick out, to poke through, to pop out"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lia̱n"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "million"
		engInfo: ""
		engUse: "numeral"
		---
		engWord: "to stick out, to poke through, to pop out"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙līn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "I, me"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙khōōn"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "show, play, drama"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙moom"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "just enough"
		engInfo: "As «I have just enough money to by one apple.»"
		engUse: "modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙n-gu̱u̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "sesame"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "loa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to plow"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "loo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "much, a lot"
		engInfo: ""
		engUse: "adjective"
		---
		engWord: "to be a lot, to be many"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "loo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "much, a lot"
		engInfo: ""
		engUse: "adjective"
		---
		engWord: "to be a lot, to be many"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "loo-loo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "very much"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "loo-loo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "very much"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "loo-tae"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "usually, mostly"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lōō"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "chinese"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lōo (loo)"
	wordIpa: "(Borrowed from Khmer)"
	wordReviewed: false
	wordNotes: "This l is not glotalized as it comes from khmer."
	engArray: [
		engWord: "dozen"
		engInfo: ""
		engUse: "specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "luq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to spread, to paint, to apply"
		engInfo: "As «to apply lipstick»"
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lua̱n"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to swallow"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "lōp (lup)"
	wordIpa: "(Borrowed from Khmer)"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to rub, to erase"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "luii"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "money"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙veam"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "busy, preoccupied"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "l˙veaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "thin, skinny, slender"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙geah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "red"
		engInfo: ""
		engUse: "noun, adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mp˙goi"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "yesterday"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙geaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "window"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙kna̱i"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "recently, just now, a moment ago, a while ago"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: "ma̱ɲ"
		khUse: ""
		]
	---
	wordCham: "mlaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "raw fiber (as from cotton)"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mlea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "under, below"
		engInfo: ""
		engUse: "preposition"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙naai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to bathe, to shower, to wash oneself"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙naih"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "pineapple"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m-ŋōq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "on, above, upper (part)"
		engInfo: ""
		engUse: "preposition, noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙ŋōq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "above, upper (part)"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙nīt"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "minute (of time)"
		engInfo: ""
		engUse: "specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙nūūŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "some"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙ɲiim"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to weave"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙ɲum"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to drink"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙ɲu̱q luq-bōuq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "hair-oil"
		engInfo: "People used to use oil to make their hair look good. Not used anymore."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙ɲu̱q-masīn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "motor-oil"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙ɲu̱q"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "oil"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙ɲu̱q-saŋ"
	wordIpa: "(saŋ) is borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "gasoline"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙p̱ia̱n-maai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "when (in the past) ... ?"
		engInfo: "To ask for a time in the past."
		engUse: "interrogative adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙p̱ia̱n"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "when (in the future) ... ?"
		engInfo: "To ask for a time in the future."
		engUse: "interrogative adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙p̱uq taai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be sad, to be worried"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙p̱uq lak"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "drunk, intoxicated, dizzy, poisoned"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙sgouh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to battle, to war"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "soŋ-qria̱m"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "battle, war"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙sīn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "motor, machine"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙sīn-(thōōt)"
	wordIpa: "(Borrowed from Khmer)"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "camera"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙ṯea oo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to not contain"
		engInfo: "something"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "how oo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to not have, to not pocess"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙ṯūh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to wake up"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mayēai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to speak, to talk"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mayēai yaw-non"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "by the way, incidentally"
		engInfo: "used for making a sudden and small change of subject"
		engUse: "adverb"
		---
		engWord: "to say like that"
		engInfo: "used for pointing out someone˙s method of speaking"
		engUse: ""
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mayēai yaw-non"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "by the way, incidentally"
		engInfo: "used for making a sudden and small change of subject"
		engUse: "adverb"
		---
		engWord: "to say like that"
		engInfo: "used for pointing out someone˙s method of speaking"
		engUse: ""
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ma˙af ampoon, ma˙af"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to forgive, to excuse"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ma˙laai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "where?"
		engInfo: ""
		engUse: "interrogative adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ma˙nii, ma˙na̱i"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "here, at this location"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "maq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "at (location)"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "maq-non"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "there, over there"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "maq-non"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "there, over there"
		engInfo: "Requires pointing an exact place with your hand."
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "maq-teh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "there, over there"
		engInfo: "Requires pointing an exact place with your hand."
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "maai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "grandmother"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mea̱i"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to come (to)"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "maaq, meeq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "mother"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "you"
		engInfo: "children speaking to mother"
		engUse: "pronoun"
		---
		engWord: "I (mother to children)"
		engInfo: ""
		engUse: "pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "maaq, meeq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "mother"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "you"
		engInfo: "children to mother"
		engUse: "pronoun"
		---
		engWord: "I (mother to children)"
		engInfo: ""
		engUse: "pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "maaq, meeq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "mother"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "you"
		engInfo: "children to mother"
		engUse: "pronoun"
		---
		engWord: "I (mother to children)"
		engInfo: ""
		engUse: "pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "manuq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "chicken"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ma̱nuih"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "person, human being"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙nuih"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "person, human being"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙nuih-cōmlaiq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "a stranger"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙sam"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "sour"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙ṯea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "there is, there are"
		engInfo: ""
		engUse: "intransitive verb"
		---
		engWord: "green, young plant"
		engInfo: "When a fruit or plant is not ready to be eaten."
		engUse: "intransitive verb"
		---
		engWord: "inexperienced"
		engInfo: "Not often used to describe lack of experienced, but it can be used a figure of speech."
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙ṯea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "there is, there are"
		engInfo: ""
		engUse: "intransitive verb"
		---
		engWord: "green, young plant"
		engInfo: "When a fruit or plant is not ready to be eaten."
		engUse: "intransitive verb"
		---
		engWord: "inexperienced"
		engInfo: "Not often used to describe lack of experienced, but it can be used a figure of speech."
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙ṯea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "there is, there are"
		engInfo: ""
		engUse: "intransitive verb"
		---
		engWord: "green, young plant"
		engInfo: "When a fruit or plant is not ready to be eaten."
		engUse: "intransitive verb"
		---
		engWord: "inexperienced"
		engInfo: "Not often used to describe lack of experienced, but it can be used a figure of speech."
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙ṯea-qeq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "certainly, of course"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mee-ria̱n"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "lesson"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mē-thia̱-vii"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "village chief, commune leader"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙geq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "hot pepper, chilli"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙geq-poq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "bell peppers"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "m˙geq-klōw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "black pepper"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mīn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "emphatic particle"
		engInfo: "as «it˙s not that, it˙s this (mīn)»"
		engUse: "final particle"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "miuq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "younger uncle"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "miuq-l˙kaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "uncle (younger that parents)"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "moŋ hasaa nēw hasaa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "from on to another"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "moŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "when (in the past)"
		engInfo: ""
		engUse: "conjunction"
		---
		engWord: "from, since"
		engInfo: "Can be used to say «(from) tomorrow, I will live in phnom penh»"
		engUse: "preposition"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "moŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "when (in the past)"
		engInfo: ""
		engUse: "conjunction"
		---
		engWord: "from, since"
		engInfo: "Can be used to say «(from) tomorrow, I will live in phnom penh»"
		engUse: "preposition"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "moŋ-gu̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "consisting of, of"
		engInfo: ""
		engUse: "preposition"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "moŋ hlīn ṯōōq siit"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "from when I was a kit"
		engInfo: ""
		engUse: "phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "moŋ tsuup"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "at dawn, early in the morning"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "moŋ t˙lao"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "before, at first, in times past"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "moŋ-ka̱a̱-p˙p̱ih (moŋ-ka̱a̱-pp̱ih)"
	wordIpa: "For slang, the p is held a bit longer, instead of saying it twice."
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "at first, originally, in the beginning"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mon-ṯipēt"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "hospital"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mon-ṯ˙ga̱i"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "minister"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mooŋ"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "hour, time"
		engInfo: ""
		engUse: "noun, specifier"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "muuq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "hammer"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mul-haet"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "reason, cause"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mul-haet ni-ye̱e̱ baan"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "This is the reason why"
		engInfo: ""
		engUse: "noun phrase, verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mul-haet qeq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "What is the reason?"
		engInfo: ""
		engUse: "interrogative phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "mu̱h"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "gold"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "n˙yoo-baai"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "politics"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "naa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to roast, to braise"
		engInfo: "Commonly referring to the dry roasting of seeds, grains, and nuts on a pan over the fire."
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "naa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to roast, to braise"
		engInfo: "Commonly referring to the dry roasting of seeds, grains, and nuts on a pan over the fire."
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "naaih"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be skilled at, to be clever for"
		engInfo: ""
		engUse: "adjectival verb, modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nēw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to go"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "naqau̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "country, state"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "naqau̱-l˙ŋiw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "foreign country, abroad"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "naqau̱-p˙gang"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "france"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "naoq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "ahead, in front, forward"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "n˙gaq-p̱˙gai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to make, to cause, to lead to, to induce"
		engInfo: "As «To make someone angry»"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "n˙gaq ba̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to earn a living (by)"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "n˙gat-c˙kea"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to be careful, to take care"
		engInfo: ""
		engUse: "adjectival verb, modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ŋiet"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "dreid and salty food"
		engInfo: "Word usually used to describe to meats that have been salted and dried in the sun for preservation. Commonly fish, among the cham."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ŋin"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "wind"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ŋui"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to put on, to wear (clothing below the waist)"
		engInfo: "Used for the act of putting on clothing below the waist. Pants, Underwear, skirts, etc. Not belt and shoes."
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ŋui-couq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to dress, to wear"
		engInfo: "Refers to the entire outfit"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nii, na̱i"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "this, these, here"
		engInfo: ""
		engUse: "demonstrative pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nisīt"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "University Student"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nit"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to pity, take pity on"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nit"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to pity, take pity on"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nōn"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "that, those, there"
		engInfo: ""
		engUse: "demonstrative pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nōn-yu̱u̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "that is correct, that is right"
		engInfo: ""
		engUse: "demonstrative pronoun, adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nōōŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to carry suspended from both ends of a pole across the shoulder"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "h˙nuaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the right (side)"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nu̱u̱q-ṯam"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "the batchelor, the groom"
		engInfo: "A man that isn˙t married, or the man that is about to be married"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "numpaŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "bread"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nu̱u̱q-k˙laai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "porter, coolie"
		engInfo: "An unskilled native laborer as is customary in India, China, and some other Asian countries."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nu̱u̱q"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "child, children, offspring"
		engInfo: "A child is your own offspring"
		engUse: "noun"
		---
		engWord: "you"
		engInfo: "parent to child"
		engUse: "pronoun"
		---
		engWord: "I"
		engInfo: "child to parent"
		engUse: "pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nu̱u̱q"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "child, children, offspring"
		engInfo: "A child is your own offspring"
		engUse: "noun"
		---
		engWord: "you"
		engInfo: "parent to child"
		engUse: "pronoun"
		---
		engWord: "I"
		engInfo: "child to parent"
		engUse: "pronoun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nu̱u̱q-k˙maai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "daugher"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nu̱u̱q-l˙kaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "son"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nu̱u̱q-m˙taw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "son-in-law or daughter-in-law"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nu̱u̱q-neh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "child, children"
		engInfo: "Not your own off-spring, all children in general."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nu̱u̱q-saēh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "Student"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nu̱u̱q-neh-l˙kaai-k˙maai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "boys and girls"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nu̱u̱q-neh-l˙kaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "boys"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nu̱u̱q-neh-k˙maai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "girls"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ɲeq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to avoid"
		engInfo: "to keep away from, or prevent doing something"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ɲiim"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to borrow"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ɲōp"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "fast, quick, frequent"
		engInfo: "Capable of repetitive motion in short succession such as a fan, sewing machine, or a fast paced song. Can also be used to describe frequent visits."
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ɲuk"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to dive, to go under water"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ŋaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to do"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "oaq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to rub, to wipe"
		engInfo: "To remove dirt or dust with the use of dry friction"
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "omnaaic"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "power, authority"
		engInfo: "The right to give orders, make decisions, and enforce obedience."
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "omnaoa̱i"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "gift"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "sāā-t˙kāh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to gift"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "oŋ-saa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "degree of temperature"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ōŋlee"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "English"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "paŋ-saa ōŋlee"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "English (language)"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "nakau̱ ōŋlee"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "England"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ōntoq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "in order to"
		engInfo: ""
		engUse: "conjunction"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "oo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "not, no"
		engInfo: ""
		engUse: "exclamation, adverb"
		---
		engWord: "negative auxiliary"
		engInfo: ""
		engUse: "aux"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "oo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "not, no"
		engInfo: ""
		engUse: "exclamation, adverb"
		---
		engWord: "negative auxiliary"
		engInfo: ""
		engUse: "aux"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ao̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "grandfather"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "ōt"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to iron (clothes)"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙aa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "paper"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙aa-ghak"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "letter"
		engInfo: "A letter written to send in the mail"
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙p̱ih"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "most, most of all"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙cah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to break, to shatter"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙cah-kāk"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "fractured skull"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙cah qaoq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to race, to compete"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙cōp"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to finish, to  complete"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙ta̱h"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to stop, to discontinue"
		engInfo: ""
		engUse: "intransitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙dāa̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to walk together"
		engInfo: "To walk next to someone, or walk a pet."
		engUse: "transitive verb"
		---
		engWord: "simultaneously"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙dāa̱"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to walk together"
		engInfo: "To walk next to someone, or walk a pet."
		engUse: "transitive verb"
		---
		engWord: "simultaneously"
		engInfo: ""
		engUse: "adverb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙gaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to give"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "for, in behalf of, instead of"
		engInfo: ""
		engUse: "directional verb"
		---
		engWord: "to allow, to let, to make, to cause"
		engInfo: ""
		engUse: "modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙gaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to give"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "for, in behalf of, instead of"
		engInfo: ""
		engUse: "directional verb"
		---
		engWord: "to allow, to let, to make, to cause"
		engInfo: ""
		engUse: "modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙gaai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to give"
		engInfo: ""
		engUse: "transitive verb"
		---
		engWord: "for, in behalf of, instead of"
		engInfo: ""
		engUse: "directional verb"
		---
		engWord: "to allow, to let, to make, to cause"
		engInfo: ""
		engUse: "modal verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱˙gah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "uncooked (husked) rice"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "swollen, inflated"
		engInfo: "The way animals swell when they die was used as an example."
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱˙gah"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "uncooked (husked) rice"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "swollen, inflated"
		engInfo: "The way animals swell when they die was used as an example."
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱˙guq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "work"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "rotten"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱˙guq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "work"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "rotten"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p̱˙guq-s˙baai-sukaa"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "happiness"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙hael-qauq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "similar, almost the same"
		engInfo: ""
		engUse: "adjective"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙c̱uun"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to send out, to send away"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙c̱uun nēw k˙p̱lai nakau̱ l˙ŋiw"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to export"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙c̱a̱ŋ"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to carry"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙kaeq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to make to fight (animals)"
		engInfo: ""
		engUse: "verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙kan-daai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "receipt"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "hand-rail"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙kan-daai"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "receipt"
		engInfo: ""
		engUse: "noun"
		---
		engWord: "hand-rail"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙kaw-jouq"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "cigarette"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙qee"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "tomorrow"
		engInfo: ""
		engUse: "noun"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙klōh"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to cut, to split, to break"
		engInfo: "to cause something long to break by force or cutting"
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙koo"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to pile up, to bunch up"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙kōt"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to assure, to be sure"
		engInfo: ""
		engUse: "adjectival verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙quu"
	wordIpa: ""
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to make a pair, to pair up, to match, to arrange a marriage"
		engInfo: ""
		engUse: "transitive verb"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙lōōŋ"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to take an examination"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙lōōŋ qam"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to pass an exam"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
	---
	wordCham: "p˙mataai (pam˙tai)"
	wordIpa: "Borrowed from Khmer"
	wordReviewed: false
	wordNotes: ""
	engArray: [
		engWord: "to kill"
		engInfo: ""
		engUse: "verb phrase"
		]
	khArray: [
		khWord: ""
		khInfo: ""
		khUse: ""
		]
]